import { createFileRoute } from '@tanstack/react-router';

import { ServiceLinkage } from '../../components/ServiceLinkage/ServiceLinkage';

export const Route = createFileRoute('/_auth/service-linkage/')({
  component: ServiceLinkage,
});
